import { activeCampaign } from "@/mocks/dashboard";

export default function CampaignProgress() {
  const { name, progress, total, sent, pending, nextSend, status } = activeCampaign;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5">
      <div className="flex items-start justify-between mb-4 gap-3 flex-wrap">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-rocket-line text-base text-[#25D366]"></i>
            </div>
            <h3 className="font-semibold text-gray-900 text-sm">Aktif Kampanya</h3>
          </div>
          <p className="text-base font-bold text-gray-900">{name}</p>
        </div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full whitespace-nowrap">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          {status}
        </span>
      </div>

      {/* Progress bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
          <span>İlerleme</span>
          <span className="font-bold text-gray-800">%{progress}</span>
        </div>
        <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-[#25D366] rounded-full transition-all duration-700"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-3 mb-4">
        {[
          { label: "Toplam", value: total, color: "text-gray-700" },
          { label: "Gönderildi", value: sent, color: "text-emerald-600" },
          { label: "Bekliyor", value: pending, color: "text-amber-600" },
        ].map((s, i) => (
          <div key={i} className="text-center p-3 bg-gray-50 rounded-xl">
            <p className={`text-lg font-bold ${s.color}`}>{s.value}</p>
            <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 p-3 bg-amber-50 rounded-xl border border-amber-100">
        <div className="w-4 h-4 flex items-center justify-center text-amber-500 flex-shrink-0">
          <i className="ri-time-line text-sm"></i>
        </div>
        <p className="text-xs text-amber-700">
          <span className="font-semibold">Sonraki Gönderim:</span> {nextSend}
        </p>
      </div>
    </div>
  );
}